

export default function (url, service, req) {
    let keys = Object.keys(url);

    keys.forEach(k => {
        if (!service.hasOwnProperty(k)) {
            service[k] = function (state, data) {

                let tData = data;
                let val = url[k];
                let tmp = val.split('|');
                let method = 'get';
                let tUrl = val;
                if (tmp && tmp.length == 2) {
                    method = tmp[0];
                    tUrl = tmp[1];
                }
                //tUrl = buildUrl(tUrl, tData);
                switch(method) {
                    case 'get':
                        return req.get(tUrl, tData);
                    case 'post':
                        return req.post(tUrl, tData);
                    case 'patch':
                        return req.patch(tUrl, tData);
                    case 'delete':
                        return req.delete(tUrl, tData);
                    default:
                        console.log(tUrl + '\n暂不支持:' + method + ', 只支持 get, post, patch 其他方法请自定义');
                }
                return Promise.reject('不支持的请求方式');
            };

        } else {
            console.log('已自定义接口:' + k);
        }
    });

}
